module.exports = __webpack_public_path__ + "media/images/country_flags/ax-d43f78a732db2a637e86fdf82efb2294.png";